import { render, staticRenderFns } from "./ExpiringTrials.vue?vue&type=template&id=2bf41669&scoped=true&"
import script from "./ExpiringTrials.vue?vue&type=script&lang=js&"
export * from "./ExpiringTrials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf41669",
  null
  
)

export default component.exports